import { actions } from '@src/mirrorx'
import { cookie, urlQuery, sessionStorage } from '@src/utils'

function pureLoginCb (passport, event, cfg, successFn) {
  switch (event) {
    case 'logined':
      // successFn()
      break
    case 'unlogined':
      window.passport.show = false
      cookie.set('userInfo', '')
      showLogin(passport, { ...cfg, nowait: true })
      break
    case 'phoneupgrade':
      break
    case 'emailupgrade':
      break
    case 'upgradesuccess':
      successFn()
      break
    case 'upgradefailed':
      break
    case 'phoneregistersuccess':
      successFn()
      break
    case 'emailregistersuccess':
      successFn()
      break
    case 'phoneregisterfailed':
      break
    case 'emailregisterfailed':
      break
    case 'phoneloginsuccess':
      successFn()
      break
    case 'emailloginsuccess':
      successFn()
      break
    case 'phoneloginfailed':
      break
    case 'emailloginfailed':
      break
    case 'networkerror':
      break
    default:
  }
}

function securityCb (passport, event, securityUser, cfg) {
  console.log('securityCb', event)
  switch (event) {
    case 'unlogined':
      cookie.set('userInfo', '')
      window.passport.show = false
      showLogin(passport, { ...cfg, nowait: true })
      break
    case 'phonesecuritysettingsuccess':
      securitySuccess(passport, event, securityUser, cfg)
      break
    case 'emailsecuritysettingsuccess':
      securitySuccess(passport, event, securityUser, cfg)
      break
    case 'phonesecuritysettingfailed':
      break
    case 'emailsecuritysettingfailed':
      break
    case 'securitysuccess':
      securitySuccess(passport, event, securityUser, cfg)
      break
    case 'securityfailed':
      break
    case 'networkerror':
      break
    default:
  }
}

async function securitySuccess (passport, event, securityUser, cfg) {
  cfg.successFn(event, securityUser)
  cfg.securitySuccessFn(securityUser)
  // await showInfo(Lang.anan_resp_common_zafam_to_zainsure || '你即將離開 ZA Fam 進入 ZA Insure', 2)
  passport.hide()
}

function passportCfg (passport, site, cfg, callback) {
  const channel = urlQuery('channel')
  const channels = {
    ED: 1200010001
  }
  passport.config({
    site: site,
    isShow: true,
    isHideCloseBtn: cfg.isHideCloseBtn,
    sourceCode: channels[channel] || 1200000001,
    callback: function (event, userInfo, err) {
      console.log('passport callback', event, userInfo, err)
      if (err) return
      if (event === 'hidepassport' || event === 'securitysuccess' || userInfo) {
        window.passport.show = false
        cfg.closeFn && cfg.closeFn()
      }
      callback && callback(passport, event, userInfo, cfg)
    }
  })
}

function showSecurity (passport, site, cfg) {
  setTimeout(() => {
    passportCfg(passport, site, cfg, function (passport, event, securityUser) {
      securityCb(passport, event, securityUser, cfg)
    })
  }, 500)
}

function clear () {
  const cuid = urlQuery('cuid')
  sessionStorage.remove('oldOcrData-' + cuid)
  sessionStorage.remove('newOcrData-' + cuid)
  cookie.unset('nodejs_sid_anan')
}

async function showLogin (passport, cfg = {}) {
  if (!passport) {
    console.warn('passport', passport)
    return
  }

  if (!window.passport) window.passport = {}
  if (window.passport.show) return
  window.passport.show = true
  let zafamUser
  try {
    zafamUser = cookie.get('userInfo')
    zafamUser = JSON.parse(decodeURIComponent(zafamUser))
  } catch (e) {}
  const defaultLogin = 'emailLogin'
  const defaultCfg = {
    loginType: defaultLogin,
    successFn: cfg.successFn || function () {},
    failFn: cfg.failFn || function () {},
    closeFn: cfg.closeFn || function () {},
    pure: cfg.pure || false,
    currentUser: zafamUser || null,
    securitySuccessFn: cfg.securitySuccessFn || function () {},
    isHideCloseBtn: cfg.isHideCloseBtn || false
  }
  // if (!cfg.nowait) await showInfo(Lang.anan_resp_common_zainsure_to_zafam || '你即將離開 ZA Insure 進入 ZA Fam', 2)

  const getSecurityType = (usr) => usr.securityPwdFlag === 1 ? 'security' : (usr.mainAuthType === 1 ? 'securitySetting' : 'securitySettingEmail')
  if (defaultCfg.pure === true) {
    passportCfg(passport, defaultLogin, defaultCfg, function (passport, event, userInfo) {
      const pureSuccess = async function () {
        defaultCfg.successFn(event, userInfo)
        actions.mainModel.setZafamUser({
          ...userInfo,
          isLogin: true
        })
        clear()
        // await showInfo(Lang.anan_resp_common_zafam_to_zainsure || '你即將離開 ZA Fam 進入 ZA Insure', 2)
        passport.hide()
      }
      pureLoginCb(passport, event, defaultCfg, pureSuccess)
    })
  } else {
    const currentUser = defaultCfg.currentUser
    const isLogin = (currentUser && currentUser.securityPwdFlag !== undefined)
    actions.mainModel.setForceLogin(false)
    const site = (!cfg.forceLogin && isLogin) ? getSecurityType(currentUser) : defaultLogin
    passportCfg(passport, site, defaultCfg, function (passport, event, userInfo, err) {
      const loginSuccess = function () {
        actions.mainModel.setZafamUser({
          ...userInfo,
          isLogin: true
        })
        clear()
        const securitySite = getSecurityType(userInfo)
        showSecurity(passport, securitySite, defaultCfg)
      }
      if (site === defaultLogin) {
        pureLoginCb(passport, event, defaultCfg, loginSuccess)
      } else {
        securityCb(passport, event, userInfo, defaultCfg, err)
      }
    })
  }
}

export default {
  showLogin
}
